module.exports = __webpack_public_path__ + "static/media/EngagingTechIcons.c1f23aec.ttf";